<template>
    <li class="list-group-item drop-down-hover" data-test="locationItem">
    	<div class="d-flex justify-content-between align-items-center">
			<div v-if="location.primary" class="text-blue-700 font-weight-bold mb-2">
                {{ location.label || 'Primary Location' }} <i class="fas fa-star text-2xs align-text-top text-blue-500"></i>
            </div>
			<div v-else class="text-blue-700 font-weight-bold mb-2"  v-html="location.label || 'Secondary Location'" />

			<div class="drop-down dropleft text-transform-none">
				<a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-test="contextMenu">
					<i class="far fa-ellipsis-h text-xl"></i>
				</a>
				<div class="dropdown-menu py-0" aria-labelledby="dropdownMenuLink">
					<a v-if="location.address" target="_blank" class="dropdown-item" :href="'https://www.google.com/maps/dir/?api=1&dir_action=navigate&destination=' + destination" v-on:click.stop>Navigate here</a>
					<a class="dropdown-item" @click="startEditing()" data-test="editLocationLink">Edit Location</a>
					<a v-if="!location.primary" class="dropdown-item" @click="setPrimaryLocation()" data-test="setPrimaryLocationLink">Set as Primary</a>
					<a class="dropdown-item" @click="deleteLocation()" data-test="deleteLocationLink">Delete Location</a>
				</div>
			</div>
		</div>

        <template v-if="!editing">
            <div class="mb-2" v-html="location.formatted_address"></div>
            <div v-if="location.phone">{{ location.phone }}</div>
            <div v-if="location.fax">{{ location.fax }} <span class="text-gray-600">(fax)</span></div>
        </template>

        <div v-else>
            <form @submit.prevent="updateLocation" @keydown="form.onKeydown($event)" @change="form.onKeydown($event)" class="mb-0">
            <div class="form-group">
                <input class="form-control" v-model="form.label" placeholder="Name/Label" data-test="editLocationLabel">
            </div>

            <div class="row no-gutters mb-2">
                <div class="col-8 pr-1">   
                <input class="form-control" v-model="form.address" placeholder="Address" data-test="editLocationAddress">
            	</div>
            	<div class="col-4 pl-1">
                    <input class="form-control" v-model="form.address_2" placeholder="Address 2" data-test="editLocationAddress2">
                </div>
            </div>

            <div class="form-group">
                <input v-model="form.city" class="form-control mb-1" placeholder="City" data-test="editLocationCity">

	            <div class="d-flex align-items-center">
	                <div class="mr-2" style="width:100px;">    
                        <v-select
                            label="label"
                            :select-on-key-codes="[9, 13]"
                            :options="options.states"
                            :reduce="label => label.id"
                            v-model="form.state"
                            data-test="editLocationState"
                        />
	                </div>             
	                <input v-model="form.zip" class="form-control" placeholder="Zip" style="width:100px;" data-test="editLocationZip">
	            </div>
	        </div>

            <div class="row no-gutters mb-3">
                <div class="col pr-1">
                	<input class="form-control" v-model="form.phone" placeholder="Phone" data-test="editLocationPhone">
                </div>
                <div class="col pl-1">
                	<input class="form-control" v-model="form.fax" placeholder="Fax" data-test="editLocationFax">
                </div>
            </div>

            <div class="form-group text-right">
                <span v-if="editing" class="btn btn-ghost-secondary" @click="stopEditing()">Cancel</span>
                <span v-if="editing" class="btn btn-primary" @click.prevent="updateLocation()" data-test="saveEditLocationButton">Save</span>
            </div>
        </form>
        </div> 
    </li>
</template>

<script>

    import { mapState } from 'vuex';
    import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';

	export default {
		components: {
            HasError,
            AlertError,
            AlertErrors,
            AlertSuccess,
            Form
		},

		props: ['location'],

		data() {
			return {
                editing: false,
                form: {},
			}
		},

        methods: {
            startEditing() {
                this.editing = true;
                this.form = new Form({
                    label:     this.location.label,
                    primary:   this.location.primary,
                    address:   this.location.address,
                    address_2: this.location.address_2,
                    city:      this.location.city,
                    state:     this.location.state,
                    zip:       this.location.zip,
                    phone:     this.location.phone,
                    fax:       this.location.fax,                    
                });
            },

            stopEditing() {
                this.editing = false;
            },

            updateLocation() {
                this.form.put('/api/locations/' + this.location.id).then(({ data }) => { 
                    this.$emit('update-location', data);
                    this.editing = false;
                    Swal.fire({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        icon: 'success',
                        title: 'Location saved',
                    });                     
                })
            },

            setPrimaryLocation() {
                this.$root.$emit('set-primary-location', this.location.id);
            },

            deleteLocation() {
                Swal.fire({
                      title: 'Are you sure?',
                      text: 'You will not be able to recover this location.',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonText: 'Delete location',
                      cancelButtonText: 'Keep location',
                      animation: false,
                    }).then((result) => {
                        if (result.value) {
                            axios.delete('/api/locations/' + this.location.id, this.location.id)
                                .then(() => {
                                    this.$emit('delete-location', this.location.id);                                
                            })
                        }
                    }
                );                
            }

        },

        computed: {
			destination() {
				var address = this.location.address ? this.location.address + ',' : ''; //simple null handling
				return encodeURIComponent(address + this.location.city + ',' + this.location.state);
			},
            ...mapState(['options'])
		}
	}

</script>

<style>
   /* .address-street { font-weight:bold; }*/
</style>